import { useState, useEffect } from 'react';

export default function StickyContactStrip() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      {/* Desktop - Top Sticky */}
      <div className={`hidden md:block fixed top-0 left-0 right-0 z-50 transition-transform duration-300 ${isVisible ? 'translate-y-0' : '-translate-y-full'}`}>
        <div className="bg-yellow-500 text-black py-3 px-6">
          <div className="max-w-7xl mx-auto flex items-center justify-between">
            <div className="flex items-center gap-3">
              <i className="ri-phone-line text-2xl"></i>
              <span className="font-bold text-lg">Call or Text (786) 327-2644</span>
              <span className="text-black/70">•</span>
              <span className="font-semibold">Book Your Mobile Detail Today</span>
            </div>
            <a
              href="tel:+17863272644"
              className="bg-black text-yellow-500 px-6 py-2 rounded-full font-bold hover:bg-gray-900 transition-all whitespace-nowrap cursor-pointer"
            >
              Call Now
            </a>
          </div>
        </div>
      </div>

      {/* Mobile - Bottom Sticky */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-yellow-500 text-black py-4 px-4 shadow-2xl">
        <div className="flex items-center justify-between gap-3">
          <div className="flex-1">
            <p className="font-bold text-sm">Book Your Detail</p>
            <p className="text-xs text-black/70">(786) 327-2644</p>
          </div>
          <div className="flex gap-2">
            <a
              href="tel:+17863272644"
              className="bg-black text-yellow-500 px-4 py-2.5 rounded-full font-bold hover:bg-gray-900 transition-all whitespace-nowrap cursor-pointer text-sm inline-flex items-center gap-1"
            >
              <i className="ri-phone-line"></i>
              Call
            </a>
            <a
              href="sms:+17863272644"
              className="bg-black text-yellow-500 px-4 py-2.5 rounded-full font-bold hover:bg-gray-900 transition-all whitespace-nowrap cursor-pointer text-sm inline-flex items-center gap-1"
            >
              <i className="ri-message-3-line"></i>
              Text
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
